<template>
    <div class="dashboard_contents">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <tabs>
                        <tab  name="Уведомления" :selected="true">
                            <tab-notice type="INFO"/>
                        </tab>
                        <tab  name="Запросы">
                            <tab-notice :user="user" type="INTERACTIVE"/>
                        </tab>
                        <tab  name="Выплаты">
                            <tab-notice type="PAYMENTS"/>
                        </tab>
                    </tabs>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import Tabs from './Profile/tabs/Tabs'
import Tab from './Profile/tabs/Tab'
import TabNotice from './Profile/tabs/TabNotice/TabNotice'

export default {
    props:['user'],
    name: "VolunteerBackendNotificationComponent",
    components: {
        Tabs,
        Tab,
        TabNotice,
    },

    data(){
        return{

            time1: null,
            time2: null,
            time3: null,
            activeComponent: null,
            selectCategory:{
                placeholder: 'Категории',
                list: [
                    {
                        title: 'запросы на кураторство/новый дом',
                    },
                    {
                        title: 'Перечисления средств',
                    },
                    {
                        title: 'Комментарии под своими и отслеживаемыми подопечными',
                    },
                    {
                        title: 'Ответы на запросы',
                    },
                    {
                        title: 'Приветственное уведомление',
                    }

                ]
            },
            selectStatus:{
                placeholder: 'Статус',
                list: [
                    {
                        title: 'На модерации',
                    },
                    {
                        title: 'Отклонено',
                    },
                    {
                        title: 'Одобрено',
                    }

                ]
            },
        }
    },

    computed: {
        currentUserData() {
            return this.$store.getters.getUserData;
        },
    },

/*    methods: {

        markAsReadTab( name ){

            this.activeComponent = name

            switch( this.activeComponent ){
                case "Уведомления":
                    this.activeComponent = 'info'
                    break;
                case "Запросы":
                    this.activeComponent = 'interactive'
                    break;
                case "Выплаты":
                    this.activeComponent = 'payments'
                    break;
            }

            if( this.activeComponent === 'info' || this.activeComponent === 'payments' ){
                this.$refs[this.activeComponent].markAsRead( this.activeComponent )
            }

        }

    },*/


}
</script>

<style lang="scss">

.dashboard_contents .tabs__navigation-item + .tabs__navigation-item {
    border-left: none;
}

</style>
